import { render } from "./ModalExpedir.vue?vue&type=template&id=51521029"
import script from "./ModalExpedir.vue?vue&type=script&lang=js"
export * from "./ModalExpedir.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__